import React, { useState } from "react";
import {
  FormLabel,
  FormGroup,
  FormControl
} from "react-bootstrap";
import "./Signup.css";
import Button from 'react-bootstrap/Button'

export default function Signup(props) {
  const INITIALSTATE = {
    email: "",
    password: "",
    confirmPassword: "",
    confirmationCode: ""
  }  
  const [newUser, setNewUser] = useState(null);
  const [
    { email, password, confirmPassword, confirmationCode },
    setState
  ] = useState(INITIALSTATE);
  const validateForm = () =>{
    return (
      email.length > 0 && password.length > 0 && password === confirmPassword
    );
    
  }

  const validateConfirmationForm = () =>{
    return confirmationCode.length > 0;
  }

  const handleChange = event => {
    const { name, value } = event.target;
    setState(prevState => ({ ...prevState, [name]: value }));
  }

  const handleSubmit = async event => {
    event.preventDefault();
    setNewUser("test");
  }

  const handleConfirmationSubmit = async event => {
    event.preventDefault();
  }

  const renderConfirmationForm = () =>{
    return (
      <form onSubmit={handleConfirmationSubmit}>
        <FormGroup controlId="confirmationCode" bsSize="large">
          <FormControl
            autoFocus
            type="tel"
            value={confirmationCode}
            onChange={handleChange}
          />
        </FormGroup>
        <Button
            block
            bsSize="large"
            disabled={!validateConfirmationForm()}
            type="Signup"
          >
            Login
          </Button>
      </form>
    );
  }

  const renderForm = () =>{
    return (
      <form onSubmit={handleSubmit}>
        <FormGroup controlId="email" bsSize="large">
          <FormLabel>Email</FormLabel>
          <FormControl
            autoFocus
            type="email"
            name="email"
            value={email}
            onChange={handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <FormLabel>Password</FormLabel>
          <FormControl
            value={password}
            onChange={handleChange}
            type="password"
            name="password"
          />
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <FormLabel>Confirm Password</FormLabel>
          <FormControl
            value={confirmPassword}
            onChange={handleChange}
            type="password"
            name="confirmationPassword"
          />
        </FormGroup>
        <Button
            block
            bsSize="large"
            disabled={!validateForm()}
            type="Signup"
          >
            Signup
          </Button>
      </form>
    );
  }

 
	return (
	  <div className="Signup">
		{newUser === null
		  ? renderForm()
		  : renderConfirmationForm()}
	  </div>
	);
  
}
